import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import cn from 'classnames';

import { Heading4 } from '../../../Text';

import * as css from './SwingThreadButton.css';
import { type ButtonVariants } from './SwingThreadButton.css';

type SwingThreadButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: ButtonVariants['variant'];
};

export const SwingThreadButton = ({
    children,
    variant = 'fill',
    className,
    ...props
}: PropsWithChildren<SwingThreadButtonProps>) => (
    <button className={cn(css.swingThreadButton({ variant }), className)} {...props}>
        <Heading4 as="span">{children}</Heading4>
    </button>
);
